import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import jwtDecode from 'jwt-decode';
import type { RmClaims } from 'src/api/queries/user';
import { EnterpriseBillingPage } from 'src/apps/fleet/app/pages/EnterpriseBillingPage';
import { authHelpers } from 'src/utils/authHelpers';
import { AccessDeniedError } from 'src/utils/errors';
import { userHelpers } from 'src/utils/userHelpers';
import { z } from 'zod';

const enterpriseBillingPageSearchSchema = z.object({
  switchToAnnualPlan: z.enum(['select-seats', 'confirm']).optional(),
  switchToMonthlyPlan: z.enum(['confirm']).optional(),
  abortSwitchToAnnualPlan: z.enum(['confirm']).optional(),
  abortSwitchToMonthlyPlan: z.enum(['confirm']).optional(),
});

export type EnterpriseBillingPageSearch = z.infer<
  typeof enterpriseBillingPageSearchSchema
>;

export const Route = createFileRoute(
  '/_auth/enterprise/_with-org/_layout/billing'
)({
  validateSearch: zodValidator(enterpriseBillingPageSearchSchema),
  async beforeLoad({ context }) {
    const auth = await context.auth;
    const accessToken = await authHelpers.getAccessTokenSilently(auth);
    const claims = jwtDecode<RmClaims>(accessToken);

    if (!userHelpers.hasPermissionReadSubscription(claims)) {
      throw new AccessDeniedError(
        'You do not have permission to view this page. Please contact your IT admin to request access.'
      );
    }
  },
  component: () => <EnterpriseBillingPage />,
});
